<template>
  <div class="Footer content" :class="{xuanfuBox:xuanfuBool}">
    <span>
      <img src="/static/images/gongan.png">皖公网安备11011278044298号、雪帝数字音频有限公司、皖ICP备2056707014号-1、
    </span>
    <span>Copyright © 2010-2024</span>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props:['xuanfuBool'],
  data () {
    return {}
  }
}
</script>

<style scoped lang='less'>
  div.Footer{
    margin-top: 50px;
    margin-bottom: 20px;
    line-height: 2em;
    //text-align: center;
    div{
      margin-bottom: 20px;
      i{
        font-size: 28px;
        margin-right: 10px;
        &:last-child{
          margin: 0;
        }
      }
    }
    div.payType{
      img{
        height: 33.4px;
        float: right;
        margin-right: 10px;
        background: #FFFFFF;
        padding: 5px;
        border-radius: 5px;
      }
    }
    span{
      display: block;
      img{
        width: 15px;
        margin-top: -5px;
        margin-right: 5px;
      }
    }
    &.xuanfuBox{
      margin:0;
      div{
        margin-top: 0px;
        margin-bottom: 0px;
        i{
          font-size: 18px;
          margin-right: 5px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue